import { MemberAlias } from '@nextforce/api'
import { makeStyles, Text } from '@rneui/themed'
import { t } from 'app/i18l'
import { View, ViewStyle } from 'react-native'
import { CheckBox } from 'shared/components/check_box'

export function MemberAliasItem({
  item,
  selected,
  onToggle,
  disabled = false,
  containerStyle,
}: {
  item: MemberAlias
  selected: boolean | undefined
  onToggle: (alias: MemberAlias) => void
  disabled?: boolean
  containerStyle?: ViewStyle
}) {
  const styles = useStyles()
  return (
    <View key={item} style={[styles.aliasRow, containerStyle]}>
      <Text style={styles.aliasText}>{getAliasDisplayName(item)}</Text>
      <CheckBox
        checked={selected}
        onPress={() => onToggle(item)}
        disabled={disabled}
      />
    </View>
  )
}

export function getAliasDisplayName(alias: MemberAlias): string {
  switch (alias) {
    case 'allAdmins':
      return t('allAdmins')
    case 'allObservers':
      return t('allObservers')
    case 'allManagers':
      return t('allManagers')
    case 'allCrew':
      return t('allCrew')
    case 'crewNewHires':
      return t('newHires')
    case 'allStaff':
      return t('allStaff')
    case 'allGuests':
      return t('allGuests')
    case 'allSeniorManagers':
      return t('allSeniorManagers')
    default:
      return alias
  }
}

const useStyles = makeStyles(theme => ({
  aliasRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: 16,
    height: 50,
    borderBottomWidth: 1,
    borderBottomColor: theme.colors?.grey5,
  },
  aliasText: {
    fontSize: 14,
  },
}))
